import {ReactComponent as CompassIcon} from '#/components/icons/ico-compass.svg';
import {useModalContext} from '#/contexts/modal-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {EllipsisHorizontalIcon, HomeIcon} from '@heroicons/react/24/solid';
import {Link, useLocation, useNavigate} from 'react-router-dom';

const NavItem = ({
  label,
  href,
  icon,
  onClick,
}: {
  label: string;
  href: string;
  icon: React.ReactNode;
  onClick?: () => void;
}) => {
  if (onClick && !href) {
    return (
      <div className='flex flex-col items-center justify-center' onClick={onClick}>
        <div className='w-6 h-6 stroke-transparent'>{icon}</div>
        <div>{label}</div>
      </div>
    );
  }
  if (!onClick && !!href) {
    return (
      <Link to={href} className='flex flex-col items-center justify-center'>
        <div className='w-6 h-6 stroke-transparent'>{icon}</div>
        <div>{label}</div>
      </Link>
    );
  }
  return null;
};

const ToggleGroup = ({items}) => {
  const getButtonStyle = (selected: boolean) =>
    `px-2 rounded-full ${selected ? 'bg-deepblue text-white' : 'bg-white text-gray-600'}`;

  return (
    <div className='flex bg-white rounded-full p-1 font-medium'>
      {items.map(item => (
        <button className={getButtonStyle(item.selected)} onClick={item.action}>
          {item.label}
        </button>
      ))}
    </div>
  );
};

export const MobileNaviation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {open, modals} = useModalContext();
  const navList = [
    {
      label: 'Explore',
      href: '/map',
      icon: (
        <CompassIcon
          className={`w-6 h-6 stroke-black ${location.pathname.includes('map') ? 'fill-deepblue' : 'fill-gray-500'}`}
        />
      ),
    },
    {
      label: 'Home',
      href: ExchangeRoute.PORTFOLIO_ACCOUNT,
      icon: (
        <HomeIcon
          className={`${location.pathname === ExchangeRoute.PORTFOLIO_ACCOUNT ? 'fill-deepblue' : 'fill-gray-500'}`}
        />
      ),
    },
    {
      label: 'More',
      href: '',
      onClick: () => {
        open({name: 'MobileNavigationModal', props: {}});
      },
      icon: (
        <EllipsisHorizontalIcon
          className={`w-6 h-6 stroke-black ${location.pathname === '/bbb' ? 'fill-deepblue' : 'fill-gray-500'}`}
        />
      ),
    },
  ];

  const isModalOpen = !!modals.length;

  const showToggle = location.pathname === ExchangeRoute.HOME || location.pathname === ExchangeRoute.MAP;

  const toggleList = [
    {
      label: 'Map',
      action: () => {
        navigate(ExchangeRoute.MAP);
      },
      selected: location.pathname.includes(ExchangeRoute.MAP),
    },
    {
      label: 'Cards',
      action: () => {
        navigate(ExchangeRoute.HOME);
      },
      selected: location.pathname === ExchangeRoute.HOME,
    },
  ];

  return (
    <>
      {showToggle && (
        <div
          className={`md:hidden sticky max-w-36 left-1/2 translate-x-[-50%] bottom-20 ${isModalOpen ? 'hidden' : 'flex'} justify-center`}
        >
          <ToggleGroup items={toggleList} />
        </div>
      )}
      <nav
        className={`md:hidden h-16 bg-white border-t-2 border-t-gray-200 sticky bottom-0 ${isModalOpen ? 'hidden' : 'flex'}  justify-around text-gray-500`}
      >
        {navList.map(({label, href, icon, onClick = undefined}) => (
          <NavItem key={label} label={label} href={href} icon={icon} onClick={onClick} />
        ))}
      </nav>
    </>
  );
};
